export default __webpack_public_path__ + "static/media/jones.239bd885.jpg";